<style type="text/css">
  .t4Property .propLabel {
    display: inline-block;
    width: 125px
  }

  .t4Property .propValue {
    display: inline-block;
    max-width: 125px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
</style>
<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" (click)="close()" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <div class="regNmbAndLock">
    <h1 [ngClass]="{'red': !object.IsEnabled }" *ngIf="object">
      {{ object.Title }}
    </h1>
    <span *ngIf="hasNfcTag" [matTooltip]="'Turbo.RentalObject.NfcTag' | translate : 'This trailer has been converted to self-service'">
      <img class="gpsLockDialog"
           src="/images/Icons/svg/DeviceUnlock.svg"
           alt="Device Lock"
           height="35"
           width="35" />
    </span>
  </div>
    
  <t4-container>
    <div class="row" *ngIf="object">
   
      <div class="col-xs-8">
        <img src="{{ object.Type.PictureUri }}" style="max-width: 150px; float: left;    margin: 0 15px 0 0" />
        <h5>{{ 'Turbo.RentalObject.lblGeneral' | translate:'General' }}</h5>
        <div class="t4Property"><span class="propLabel">{{ 'Turbo.RentalObject.lblModel' | translate:'Model' }}: </span><span class="propValue" matTooltip="{{ object.Type.Alias }}" *ngIf="object.Type.Alias">{{ object.Type.Alias}}</span><span class="propValue" matTooltip="{{ object.Type.Title }}" *ngIf="!object.Type.Alias">{{ object.Type.Title}}</span><t4-context-trace [context]="object.Type.ContextId"></t4-context-trace></div>
        <div class="t4Property"><span class="propLabel">{{ 'Turbo.RentalObject.lblAlias' | translate:'Alias' }}: </span><span class="propValue" matTooltip="{{ object.Alias }}">{{ object.Alias }}</span></div>
        <div class="t4Property"><span class="propLabel">{{ 'Turbo.RentalObject.lblPlace' | translate:'Location' }}: </span><span class="propValue"><t4-location-link [locationId]="object.RentalLocation.Id">{{ object.RentalLocation?.Name }}</t4-location-link></span></div>
        <div class="t4Property"><span class="propLabel">{{ 'Turbo.RentalObject.lblRegistrationYear' | translate:'Reg. year'}}: </span><span class="propValue" matTooltip="{{ object.RegistrationYear }}">{{object.RegistrationYear}}</span></div>
        <div class="t4Property"><span class="propLabel">{{ 'Turbo.RentalObject.lblInspectionDate' | translate:'Insp. date'}}: </span><span class="propValue" matTooltip="{{object.NextInspectionDate | date: 'yyyy-MM-dd'}}">{{object.NextInspectionDate | date: 'yyyy-MM-dd'}}</span></div>
      </div>
      <div class="col-xs-4">
        <h5>{{ 'Turbo.RentalObject.lblInterior' | translate:'Interior measurments' }}</h5>
        <div *ngFor="let attr of object?.Type?.Attributes">
          <div class="t4Property">
            <span class="propLabel">{{attr.Name | translate }}:</span>
            <span *ngIf="attr.Value" class="propValue" matTooltip="{{ attr.Value }}}">{{ attr.Value }}</span>
          </div>
        </div>
      </div>
    </div>
  </t4-container>
  <t4-container title="{{ 'Turbo.RentalObject.lblDetails' | translate:'Details' }}">
    <div class="row" *ngIf="object">
      <div class="col-xs-12">
        <mat-tab-group style="height: auto; min-height: 300px; clear: both;" (focusChange)="tabChanged($event)" [selectedIndex]="selected.value">
          <mat-tab label="{{ 'Turbo.RentalObject.Map' | translate: 'Map' }}" *ngIf="object && gpsLockId">
            <object-gps-map [lockId]="gpsLockId"></object-gps-map>
          </mat-tab>
          <mat-tab label="{{ 'Turbo.RentalObject.headSettings' | translate:'Settings'}}">
            <div class="row">
              <div class="col-xs-6">
                <mat-form-field style="width: 100%;">
                  <mat-label>{{ 'Turbo.RentalObject.tipTitle' | translate : 'Name' }}</mat-label>
                  <input type="text" matInput [required] [(ngModel)]="object.Title" [disabled]="!object.IsManual" />
                </mat-form-field>
              </div>
              <div class="col-xs-6">
                <mat-form-field style="width: 100%;" *ngIf="!object.IsManual">
                  <mat-label>{{ 'Turbo.RentalObject.tipType' | translate : 'Type' }}</mat-label>
                  <input type="text" matInput [required] [(ngModel)]="object.Type.Title" [disabled]="true" />
                </mat-form-field>
                <mat-form-field style="width: 100%;" appearance="outline" *ngIf="object.IsManual">
                  <mat-label>{{ 'Turbo.RentalObject.tipType' | translate : 'Type' }}</mat-label>
                  <mat-select [(ngModel)]="object.Type" (ngModelChange)="setType($event)" (openedChange)="resetSearch($event)" [panelClass]="'custom-dropdown'">
                    <div class="search-container" style="position: sticky; top: 0; z-index: 1; background: white; width: 100%; padding-top: 2px;">
                      <mat-form-field appearance="outline" style="width: 100%;">
                        <input matInput [(ngModel)]="searchText" (keyup)="filterTypes()" placeholder="{{ 'Turbo.RentalObject.typeToSearch' | translate : 'Type to search...' }}"
                               (click)="$event.stopPropagation()" />
                      </mat-form-field>
                    </div>
                    <mat-option *ngFor="let t of filteredObjectTypes" [value]="t">
                      <span *ngIf="t.Title.indexOf('Turbo.') >= 0">
                        {{ t.Title | translate }}
                      </span>
                      <span *ngIf="t.Title.indexOf('Turbo.') < 0"> {{ t.Title }} ({{ t.Alias }})</span>
                    </mat-option>
                  </mat-select>
                  <mat-progress-bar *ngIf="isLoadingTypes" mode="indeterminate" class="turboContainerLoader"></mat-progress-bar>
                </mat-form-field>
              </div>
            </div>
            <div class="row">

              <div class="col-xs-6">
                <mat-form-field style="width: 100%;">
                  <mat-label>{{ 'Turbo.RentalObject.tipAlias' | translate : 'Local name' }}</mat-label>
                  <input type="text" matInput [required] [(ngModel)]="object.Alias" />
                </mat-form-field>
              </div>


              <div class="col-xs-6">
                <span>
                  <mat-form-field style="width:362px">
                    <mat-label>
                      {{ 'Turbo.RentalObject.lblInspectionDatePicker1' | translate:'Select inspection date' }}
                    </mat-label>

                    <input matInput
                           [matDatepicker]="picker"
                           [(ngModel)]="object.NextInspectionDate"
                           [matTooltip]="object.NextInspectionDate | date: 'yyyy-MM-dd'"
                           (dateChange)="onDateChanged($event)">

                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </span>
              </div>

            </div>

                
           
            
                 <div class="row" style="margin-top:20px;">
                <div class="col-xs-6" style="display:flex; flex-direction:column; gap:5px;" *ngIf="object.IsManual || Settings.isInAny(['Admin', 'LocationManager'], true)">
                  <mat-checkbox [(ngModel)]="object.AvailableOnline" style="margin-right: 10px;" [disabled]="!object.IsManual && !Settings.isInAny(['Admin', 'LocationManager'], true)">{{ 'Turbo.RentalObject.chkAvailableOnline' | translate : 'AvailableOnline'}}</mat-checkbox>
                  <mat-checkbox [(ngModel)]="object.ShowInUse4Free" [disabled]="!object.IsManual && !Settings.isInAny(['Admin'], true)">{{ 'Turbo.RentalObject.chkShowInUse4Free' | translate : 'Show in Use4Free'}}</mat-checkbox>
                </div>
              </div>
            <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px; margin-top: 40px; width: 100%;">
              <button mat-stroked-button (click)="openObjectEditor(object)" *ngIf="object.IsDeleted">{{ 'Turbo.RentalObject.cmdConvert' | translate : 'Convert Object' }}</button>
              <span *ngIf="isSaved" style="color: #1e9b38; margin-left: 10px;">{{ 'Turbo.RentalObject.cmdSaved' | translate : 'Saved!'}}</span>
              <button mat-flat-button color="primary" (click)="updateSettings()">{{ 'Turbo.RentalObject.cmdSave' | translate : 'Save' }}</button>

            </div>
          </mat-tab>
          <mat-tab label="{{ 'Turbo.RentalObject.headEvents' | translate:'Latest events'}}">
            <div class="list-item" [ngClass]="{ 'lateResource': item.Status == 1 }" *ngFor="let item of object.Movements">
              <div *ngIf="item.Type == 'Bokning'">
                <div style="float: left;text-align: center; margin: 0px 6px; text-align: center; color:#e52a16" *ngIf="item.Status == 1"><mat-icon>clear</mat-icon><br />&nbsp;</div>
                <div style="float: left; text-align: center; margin: 5px 6px;" *ngIf="item.Status != 1"><div class="statusIcon" style="margin-bottom: 9px;" [ngClass]="{'status-green': item.Status == 200, 'status-red': (item.Status == 150), 'status-yellow': (item.Status == 100), 'status-lightgreen': (item.Status == 50) }"></div><mat-icon>person</mat-icon></div>
                <t4-booking-link bookingId="{{ item.BookingId }}" style="float: right;"></t4-booking-link>
                <div><mat-icon style="margin-right: 5px;">flight_land</mat-icon><span style="display: inline-block; min-width: 50px;">{{ item.EndTime | date : 'yyMMdd' }}</span><span>{{ item.ToLocation }}</span></div>
                <div style="margin-top: 5px;"><mat-icon style="margin-right: 5px;">flight_takeoff</mat-icon><span style="display: inline-block; min-width: 50px;">{{ item.StartTime | date : 'yyMMdd' }}</span><span>{{ item.FromLocation }}</span></div>
              </div>
              <div *ngIf="item.Type == 'Vagnsflytt'">
                <div style="float: left;text-align: center; margin: 0px 6px; text-align: center;"><mat-icon>local_shipping</mat-icon></div>
                <div>
                  <mat-icon style="margin-right: 5px;">flight_land</mat-icon><span style="display: inline-block; min-width: 50px;">{{ item.EndTime | date : 'yyMMdd' }}</span><span>{{ item.ToLocation }}</span>
                </div>
              </div>
              <div *ngIf="item.Type == 'Correction'" class="red">
                <div style="float: left;text-align: center; margin: 0px 6px; text-align: center;"><mat-icon>report</mat-icon></div>
                <div><mat-icon style="margin-right: 5px;">flight_land</mat-icon><span style="display: inline-block; min-width: 50px;">{{ item.EndTime | date : 'yyMMdd' }}</span><span>{{ item.ToLocation }}</span></div>
              </div>
            </div>
            <div style="margin-top: 13px; color: blue; cursor: pointer;" (click)="moreMovements()">Load more</div>
          </mat-tab>
          <mat-tab label="{{ 'Turbo.RentalObject.headIssues' | translate:'Latest issues'}}">
            <div *ngFor="let item of object.ServiceRequests">
              <div class="list-item" matTooltip="{{ item.Description }}" (click)="serviceRequestClicked(item)">
                <div class="statusIcon" style="float: left; margin: 12px;" [ngClass]="{'status-green': (item.Status == 50 || item.Status == 100), 'status-red': (!item.ExpectedResolveDate || item.ExpectedResolveDate < today), 'status-yellow': (item.ExpectedResolveDate < tomorrow && item.ExpectedResolveDate >= today) }"></div>
                <span style="float: right">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus_' + item.Status | translate }}</span>
                {{ item.RequestNo }} - {{ item.CreatedAt | date : 'yyyy-MM-dd HH:mm' }}<br />
                {{ item.Description }}
              </div> 
            </div>
          </mat-tab>
          <mat-tab label="{{ 'turbo.core.ObjectDialog.lblUsedParts' | translate : 'Used parts'}}" #tabUsedParts *ngIf="object.Id">
            <t4-used-parts id="{{object.Id}}" type="object" trailer="{{object.Title}}"></t4-used-parts>
          </mat-tab>
          <mat-tab label="{{ 'Turbo.RentalObject.headNotes' | translate:'Notes'}}">
            <div *ngFor="let item of notes">
              <div class="list-item" matTooltip="{{ item.Content }}">
                <div style="float: right;color: #1e9b38" *ngIf="item.Action"><mat-icon>check</mat-icon></div>
                <div style="float: right;" *ngIf="!item.Action"><button mat-raised-button style="color: #e52a16" (click)="closeNote(item)"><mat-icon>check</mat-icon></button></div>
                <button *ngIf="!item.Action" mat-raised-button type="button" color="primary" style="float: right; margin-right: 5px;" (click)="convertNoteToServiceRequest(item)" [disabled]="!canCreateServiceRequest || convertingNotes.has(item.Id)">
                  <mat-icon>build</mat-icon>
                  {{ 'Turbo.RentalObject.cmdConvertNoteToServiceRequest' | translate : 'Convert to service request' }}
                </button>
                {{ item.CreatedAt | date : 'yyyy-MM-dd HH:mm' }}<br />
                {{ item.Content }}
              </div>
            </div>
            <div *ngIf="notes.length == 0" style="text-align: center">{{ 'Turbo.RentalObject.msgNoNotes' | translate:'No active notes'}}</div>
          </mat-tab>
          <mat-tab label="{{ 'Turbo.RentalObject.Devices' | translate: 'Devices' }}">
            <button mat-mini-fab color="primary" style="z-index:101; position: absolute; right: 10px; top: 5px" *ngIf="Settings.isInAny(['Admin'], true)" (click)="connectDevice()"><mat-icon style="color: white">add</mat-icon></button>
            @if(object && object.Type && object.Type.TypeClassId == 5) {
              <button mat-button color="primary" (click)="refreshNuwielStatus()" style="z-index:101; position: absolute; right: 60px; top: 5px" *ngIf="Settings.isInAny(['Admin'], true)"><mat-icon>refresh</mat-icon><span>{{ 'Turbo.RentalObject.cmdRefreshNuwiel' | translate : 'Refresh status' }}</span></button>
            }
            <div class="row">
              <div class="col-12 mb-4"><h1>{{ 'Turbo.RentalObject.NumberOfDevices' | translate: 'Connected devices' }}: {{ object?.Locks?.length || 0}}</h1></div>
            </div>
            <div class="row" style="width: 1000px; padding: 15px" *ngFor="let lock of object.Locks; let i = index" [ngStyle]="(i % 2 == 0 && object.Locks.length > 1) ? {'background-color': '#efefef'} : {'background-color': 'white'}">
              <div class="col-4">
                <div class="col-12">
                  <h5>{{ 'Turbo.RentalObject.lblGeneral' | translate:'General' }}</h5>
                  <div class="t4Property"><span class="propLabel">{{ 'Turbo.Lock.lblDeviceId' | translate: 'Device id' }}: </span><span class="propValue" matTooltip="{{ lock.Id }}">{{ lock.Id }}</span></div>
                  <div class="t4Property" *ngIf="lock.DeviceType"><span class="propLabel">Device type: </span><span class="propValue" matTooltip="{{ getDeviceType(lock.DeviceType) }}">{{ getDeviceType(lock.DeviceType) }}</span></div>
                  <div *ngIf="lock.DeviceType != 2 && lock.Mac" class="t4Property"><span class="propLabel">Mac address: </span><span class="propValue" matTooltip="{{ lock.Mac }}">{{ lock.Mac }}</span></div>
                  <div class="t4Property" *ngIf="lock.LccId && lock.DeviceType != 2"><span class="propLabel">Batch id: </span><span class="propValue" matTooltip="{{ lock.LccId }}">{{ lock.LccId }}</span></div>
                </div>
                <div *ngIf="lock.DeviceType != 2" class="col-12 mt-2">
                  <h5>{{ 'Turbo.RentalObject.lblHealth' | translate:'Health' }}</h5>
                  <div class="t4Property"><span class="propLabel">{{ 'Turbo.Lock.lblBattery' | translate: 'Battery' }}: </span><span class="propValue" matTooltip="{{ lock.BatteryLevel }}">{{ lock.BatteryLevel }} mV</span></div>
                  <div class="t4Property" *ngIf="lock.UpdatedAt"><span class="propLabel">{{ 'Turbo.Lock.lblUpdatedAt' | translate: 'Updated' }}: </span><span class="propValue" *ngIf="lock.UpdatedAt" matTooltip="{{ lock.UpdatedAt }}">{{ lock.UpdatedAt }}</span></div>
                </div>
              </div>
              <div *ngIf="lock.DeviceType == 0" class="col-7">
                <div>
                  <t4-periodPicker [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
                </div>
                <div>
                  <t4-chart [diagramIds]="[['LCK_History', 'y-axis-0']]" title="{{'Turbo.RentalObject.BatteryHistory' | translate : 'Battery history' }}" type="line" [fromDate]="fromDate" [toDate]="toDate" [dataId]="lock.Id"></t4-chart>
                </div>
              </div>
              <div *ngIf="lock.DeviceType == 1" class="col-7">
                <div>
                  <t4-periodPicker [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
                </div>
                <div>
                  <t4-chart [diagramIds]="[['LCK_GpsHistory', 'y-axis-0']]" title="{{'Turbo.RentalObject.BatteryHistory' | translate : 'Battery history' }}" type="line" [fromDate]="fromDate" [toDate]="toDate" [dataId]="lock.Id"></t4-chart>
                </div>
              </div>
              <div class="col-1" *ngIf="Settings.isInAny(['Admin'], true)">
                <button mat-icon-button (click)="removeLock(lock)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="{{ 'turbo.core.ObjectDialog.History' | translate : 'History'}}" #tabHistory *ngIf="object.Id">
            <t4-entity-event entityId="{{object.Id}}" entityType="3"></t4-entity-event>
          </mat-tab>
        </mat-tab-group>

      </div>
    </div>
  </t4-container>

  <mat-progress-bar mode="indeterminate" style="margin-left: -24px; margin-bottom: -24px; width: calc(100% + 48px); margin-top: 24px;" *ngIf="loading.isLoading"></mat-progress-bar>
</mat-dialog-content>
<mat-dialog-actions>
</mat-dialog-actions>
